module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.save($event)
      }
    }
  }, [_c('div', {
    staticClass: "button-bar"
  }, [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": "/templates/sections"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-left"
  }), _vm._v(" Back to Section Templates")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.varHelpVisible = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  }), _vm._v(" Variable Reference\n\t\t\t\t")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Section Title",
      "col-class": "col-md-2"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.section.heading),
      expression: "section.heading"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.section.heading)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.section.heading = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Template Description",
      "col-class": "col-md-2"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.section.template_description),
      expression: "section.template_description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.section.template_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.section.template_description = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("(Template description will not appear in report)")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Introduction Template",
      "col-class": "col-md-2"
    }
  }, [_c('p', {
    staticClass: "help-block"
  }, [_vm._v("This text will appear in every report that contains this section")]), _vm._v(" "), _c('rich-text', {
    key: "intro_editor",
    attrs: {
      "id": "intro-text"
    },
    on: {
      "input": _vm.richTextChange
    },
    model: {
      value: (_vm.section.description_text),
      callback: function($$v) {
        _vm.section.description_text = $$v
      },
      expression: "section.description_text"
    }
  })], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "",
      "col-class": "col-md-2"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.section.has_guidelines),
      expression: "section.has_guidelines"
    }],
    attrs: {
      "type": "checkbox",
      "true-value": "1",
      "false-value": "0"
    },
    domProps: {
      "checked": Array.isArray(_vm.section.has_guidelines) ? _vm._i(_vm.section.has_guidelines, null) > -1 : _vm._q(_vm.section.has_guidelines, "1")
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.section.has_guidelines,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("0");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.section.has_guidelines = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.section.has_guidelines = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.section.has_guidelines = $$c
        }
      }
    }
  }), _vm._v("\n\t\t\t\tThis section has a \"Guidelines\" Sub-section\n\t\t\t")])]), _vm._v(" "), _c('form-group', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.section.has_guidelines == '1'),
      expression: "section.has_guidelines == '1'"
    }],
    attrs: {
      "label": "Guidelines Template",
      "col-class": "col-md-2"
    }
  }, [_c('p', {
    staticClass: "help-block"
  }, [_vm._v("This text will appear in every report that contains this section")]), _vm._v(" "), _c('rich-text', {
    key: "guidelines_editor",
    attrs: {
      "id": "guidelines-text"
    },
    model: {
      value: (_vm.section.guidelines_text),
      callback: function($$v) {
        _vm.section.guidelines_text = $$v
      },
      expression: "section.guidelines_text"
    }
  })], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "",
      "col-class": "col-md-2"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.section.has_findings),
      expression: "section.has_findings"
    }],
    attrs: {
      "type": "checkbox",
      "true-value": "1",
      "false-value": "0"
    },
    domProps: {
      "checked": Array.isArray(_vm.section.has_findings) ? _vm._i(_vm.section.has_findings, null) > -1 : _vm._q(_vm.section.has_findings, "1")
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.section.has_findings,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("0");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.section.has_findings = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.section.has_findings = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.section.has_findings = $$c
        }
      }
    }
  }), _vm._v("\n\t\t\t\tThis section has a \"Findings\" Sub-section\n\t\t\t")])]), _vm._v(" "), (_vm.section.has_findings == '1') ? _c('div', [_c('form-group', {
    attrs: {
      "label": "",
      "col-class": "col-md-2"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.section.pull_findings_from_section),
      expression: "section.pull_findings_from_section"
    }],
    attrs: {
      "type": "checkbox",
      "true-value": "1",
      "false-value": "0"
    },
    domProps: {
      "checked": Array.isArray(_vm.section.pull_findings_from_section) ? _vm._i(_vm.section.pull_findings_from_section, null) > -1 : _vm._q(_vm.section.pull_findings_from_section, "1")
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.section.pull_findings_from_section,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("0");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.section.pull_findings_from_section = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.section.pull_findings_from_section = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.section.pull_findings_from_section = $$c
        }
      }
    }
  }), _vm._v("\n\t\t\t\t\tPull Findings from an audit form section\n\t\t\t\t")])]), _vm._v(" "), (_vm.section.pull_findings_from_section == '1') ? _c('div', [_c('form-group', {
    attrs: {
      "label": "Form Template",
      "col-class": "col-md-2"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.section.findings_form_template_id),
      expression: "section.findings_form_template_id"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.section.findings_form_template_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.formTemplates), function(template) {
    return _c('option', {
      domProps: {
        "value": template.id
      }
    }, [_vm._v(_vm._s(template.form_name))])
  }))]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Form Section",
      "col-class": "col-md-2"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.findingsSectionNames),
      expression: "findingsSectionNames"
    }],
    staticClass: "form-control",
    attrs: {
      "multiple": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.findingsSectionNames = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.selectedFormTemplateSections), function(templateSection) {
    return _c('option', [_vm._v(_vm._s(templateSection))])
  }))])], 1) : _c('div', {
    staticClass: "col-md-offset-2 col-md-10"
  }, [_vm._v("\n\t\t\t\tFindings will be typed out manually\n\t\t\t")])], 1) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 1), _vm._v(" "), (_vm.varHelpVisible) ? _c('variable-help', {
    attrs: {
      "modal-visible": _vm.varHelpVisible
    },
    on: {
      "close": function($event) {
        _vm.varHelpVisible = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-success pull-right"
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-060a1192","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SectionTemplateEditor.vue
// module id = 262
// module chunks = 0